import { render, staticRenderFns } from "./DrawerApproverFinalGlobal.vue?vue&type=template&id=bf9e097c&scoped=true&"
import script from "./DrawerApproverFinalGlobal.vue?vue&type=script&lang=js&"
export * from "./DrawerApproverFinalGlobal.vue?vue&type=script&lang=js&"
import style0 from "./DrawerApproverFinalGlobal.vue?vue&type=style&index=0&id=bf9e097c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9e097c",
  null
  
)

export default component.exports